import { RemoveCircle } from '@mui/icons-material';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import React, { useCallback } from 'react';
import {
  useEditContext,
  usePermissions,
  useRecordContext,
  useRefresh,
  useUpdate,
} from 'react-admin';
import useDialogStatus from '../../../hooks/useDialogStatus';
import hasAccess from '../../../utilities/hasAccess';
import actions from '../../../constants/actions';

const DeleteEntities = ({
  onlyIcon = false,
}: {
  onlyIcon?: boolean;
}) => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const { record: { id } } = useEditContext();
  const record = useRecordContext();
  const [update] = useUpdate();
  const refetch = useRefresh();

  const handleClick = useCallback(() => {
    update('cases', {
      id: `${id}/detach-entity`,
      data: {
        entityId: record?.id,
        entityType: record?.type,
      },
    }, {
      mutationMode: 'pessimistic',
      onSuccess: () => {
        closeDialog();
        refetch();
      },
    });
  }, [closeDialog, id, record?.id, record?.type, refetch, update]);

  const { permissions } = usePermissions();
  if (!hasAccess(permissions, actions.CASE_MANAGE_ENTITIES)) return null;

  return (
    <>
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>Remove entity</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove the entity from the case?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={handleClick} variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>
      {onlyIcon ? (
        <Tooltip title="Remove entity from case">
          <IconButton color="error" onClick={openDialog}>
            <RemoveCircle />
          </IconButton>
        </Tooltip>
      ) : (
        <Button color="error" startIcon={<RemoveCircle />} onClick={openDialog}>
          Remove
        </Button>
      )}
    </>
  );
};

export default DeleteEntities;
